import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { Button } from '@material-ui/core';
import DHPic from '../../images/Dr-haiel3.png';

const useStyles = makeStyles({
    root: {
        maxWidth: 345,
    },
    media: {
        height: 140,
    },
    bot: {
        maxWidth: 345,
        marginLeft: 30,
        '&:before': {
            backgroundImage: `url(${DHPic})`,
            backgroundSize: '30px 30px',
            backgroundRepeat: 'no-repeat',
            content: '""',
            position: 'absolute',
            left: 10,
            width: 30,
            height: 30,
        },
    },
});

const useStyles1 = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '12ch',
        },
        display: 'flex',
        alignItems: 'center',
    },
}));

const HeightCollection = ({
    title,
    onUserInput,
    isLastMessage,
    isSelected,
}) => {
    const classes = useStyles();
    const classes1 = useStyles1();
    const [feet, setFeet] = React.useState('0');
    const [inches, setInches] = React.useState('0');
    const handleChangeFeet = (event) => {
        setFeet(event.target.value);
    };
    const handleChangeInches = (event) => {
        setInches(event.target.value);
    };
    const handleSubmit = () => {
        const finalResult = parseFloat(feet) * 12 + parseFloat(inches);
        onUserInput('user submit', finalResult.toString());
    };
    return (<Card className={classes.root, classes.bot}
        style={
            {
                marginBottom: '40px',
                backgroundColor: '#E3F5F7',
            }
        } >
        <CardContent >
            <Typography variant="h5"
                component="h2"
                style={
                    { fontSize: '1rem' }} > {title} </Typography> </CardContent> <CardActionArea >

            <Divider className={classes.divider}
            /> </CardActionArea> <form className={classes1.root}
                noValidate autoComplete="off" >
            <TextField id="feet"
                label="Feet here"
                variant="outlined"
                onChange={handleChangeFeet}
                defaultValue={feet}
            />
            Feet <TextField id="inch"
                label="Inch here"
                variant="outlined"
                onChange={handleChangeInches}
                defaultValue={inches}
            />
            Inches </form> <Button variant="contained"
                onClick={handleSubmit}
                disabled={isSelected} >
            Submit </Button> <CardActions />
    </Card>

    );
};
HeightCollection.propTypes = {
    title: PropTypes.string.isRequired,
    onUserInput: PropTypes.func.isRequired,
    isLastMessage: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool,

};
HeightCollection.defaultProps = {
    isSelected: false,
};

export default HeightCollection;


// WEBPACK FOOTER //
// ./src/components/HeightCollection/HeightCollection.js